module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedFaq && Object.keys(_vm.selectedFaq).length) ? _c('div', {
    staticClass: "faq-ques-listing-wrapper",
    class: {
      'customised-prod-faqs': _vm.callerComp === 'customised-prod-faqs'
    }
  }, [_c('faq-tab', {
    attrs: {
      "pid": ("question-wrapper-" + _vm.selectedFaqIndex)
    }
  }, _vm._l((_vm.selectedFaq && _vm.selectedFaq.menu_items), function(faq, index) {
    return _c('faq-tabcontent', {
      key: index,
      class: index === _vm.selectedFaq.menu_items.length - 1 ? 'last-card' : '',
      attrs: {
        "title": faq.question,
        "index": index,
        "dparent": ("question-wrapper-" + _vm.selectedFaqIndex),
        "areaExpanded": "false",
        "isOpen": false
      }
    }, [_c('div', {
      staticClass: "faq-content",
      domProps: {
        "innerHTML": _vm._s(faq.answer)
      }
    })])
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a1c6eaf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/faqsQuestionsListing.vue
// module id = 1140
// module chunks = 1 14 34 42 52